/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Text_ViewInputs */

const en_read_along_text_view = /** @type {(inputs: Read_Along_Text_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text view`)
};

const es_read_along_text_view = /** @type {(inputs: Read_Along_Text_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de texto`)
};

/**
* | output |
* | --- |
* | "Text view" |
*
* @param {Read_Along_Text_ViewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_text_view = /** @type {((inputs?: Read_Along_Text_ViewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Text_ViewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_text_view(inputs)
	return en_read_along_text_view(inputs)
});